﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customUserList from './tpl/customUserList.html';
import View_CustomUserListItem from './customUserListItem';

export default Marionette.CollectionView.extend({
    childViewContainer: '#customUserList',
    childView: View_CustomUserListItem,
    getTemplate: function () {
        return tpl_customUserList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});